import { useQuery } from '@tanstack/react-query'
import {
    fetchPipelineList,
    type PipelineItem,
    type PipelineListParams,
} from '@/features/adp/api/pipelineLists.api'

// ─── Types ────────────────────────────────────────────────────────────────────

export type UsePipelineListsResult = {
    /** The list of pipelines for the current page. */
    pipelines: PipelineItem[]
    /** Total count of pipelines matching the search/filter. */
    totalCount: number
    /** Whether the API request is in-flight. */
    isLoading: boolean
    /** Error message string if the fetch failed, otherwise null. */
    error: string | null
}

export type UsePipelineListsOptions = {
    enabled?: boolean
}

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function usePipelineLists(
    params: PipelineListParams = {},
    options: UsePipelineListsOptions = {}
): UsePipelineListsResult {
    const { enabled = true } = options
    const { data, isLoading, error } = useQuery<{
        pipelines: PipelineItem[]
        totalCount: number
    }, Error>({
        queryKey: ['adp', 'pipeline-lists', params],
        queryFn: () => fetchPipelineList(params),
        enabled,
        refetchOnMount: 'always',
        placeholderData: (previousData) => previousData,
        staleTime: 30_000, // 30 seconds
        // placeholderData: (previousData) => previousData,
 
    })

    return {
        pipelines: data?.pipelines ?? [],
        totalCount: data?.totalCount ?? 0,
        isLoading,
        error: error?.message ?? null,
    }
}
